import { Link } from "react-router-dom";
import React from "react";

const OnboardingWrapper = ({ children, actions, onSubmit }) => {
  return (
    <form className="min-h-full flex flex-col bg-white" onSubmit={onSubmit}>
      <div
        className="sticky top-0 p-4 flex justify-center sm:justify-start z-50 bg-white border-b border-gray-200"
        style={{ zIndex: 999999 }}
      >
        <Link to="/">
          <img alt="SupportMagic" src="/logo.png" className="h-8" />
        </Link>
      </div>

      <div className="flex-1 flex justify-center sm:items-center">
        {children}
      </div>

      {Boolean(actions) && (
        <div className="sticky bottom-0 p-4 flex justify-center sm:justify-start z-50 bg-white border-t border-gray-200 shadow">
          {actions}
        </div>
      )}
    </form>
  );
};

export default OnboardingWrapper;
